export default __webpack_public_path__ + "static/media/ico-postgress-score-elevated.2d07be9d.svg";